
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
    pending_counselling,
    pending_counselling_counts,
    update_status
} from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";

// Thunk: Fetch patients data
export const fetchPendingCounsellingPatientsData = createAsyncThunk(
    'pendingCounselling/fetchPatients',
    async ({ pharmacyId }, { rejectWithValue }) => {
        try {
            const { data } = await Axios.get(pending_counselling, {
                params: {
                    pharmacy_id: pharmacyId,
                    per_page: 50
                }
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Thunk: Fetch counts data
export const fetchPendingCounsellingCounts = createAsyncThunk(
    'pendingCounselling/fetchCounts',
    async ({ pharmacyId }, { rejectWithValue }) => {
        try {
            const { data } = await Axios.get(pending_counselling_counts, {
                params: { pharmacy_id: pharmacyId }
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Thunk: Update status
export const updateCounsellingStatus = createAsyncThunk(
    'pendingCounselling/updateStatus',
    async ({ pharmacyId,
        newRxCounsellingValues,
        dispatch }, { rejectWithValue }) => {

        const payloadData = {
            pharmacy_id: pharmacyId,
        }

        if (newRxCounsellingValues?.length > 0) {
            const formattedCounsellingNotes = {};
            newRxCounsellingValues.forEach(({ rxid, dropdownValue }) => {
                if (dropdownValue?.value) {
                    formattedCounsellingNotes[rxid] = dropdownValue.value;
                }
                payloadData.pending_counseling_note = formattedCounsellingNotes;
            });
        }

        try {
            const { data } = await Axios.post(update_status, payloadData);
            dispatch(fetchPendingCounsellingPatientsData({
                pharmacyId: pharmacyId
            }))
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Initial State
const initialState = {
    patients: { loading: false, data: null, error: null },
    counts: { loading: false, data: null, error: null },
    updateStatus: { loading: false, data: null, error: null },
};

// Helper to add reducers for a thunk
const handleAsyncThunk = (builder, thunk, key) => {
    builder
        .addCase(thunk.pending, (state) => {
            state[key].loading = true;
            state[key].error = null;
            state[key].data = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
            state[key].loading = false;
            state[key].data = action.payload;
            state[key].error = null;
        })
        .addCase(thunk.rejected, (state, action) => {
            state[key].loading = false;
            state[key].error = action.payload;
            state[key].data = null;
        });
};

// Slice
const pendingCounsellingSlice = createSlice({
    name: 'pendingCounselling',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        handleAsyncThunk(builder, fetchPendingCounsellingPatientsData, 'patients');
        handleAsyncThunk(builder, fetchPendingCounsellingCounts, 'counts');
        handleAsyncThunk(builder, updateCounsellingStatus, 'updateStatus');
    }
});

export default pendingCounsellingSlice.reducer;


// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// import Axios from "../../../networking/interceptor";

// export const fetchPendingCounsellingPatientsData = createAsyncThunk('fetchPendingCounsellingPatientsData', async ({ pharmacyId }, { rejectWithValue }) => {
//     try {
//         const params = {
//             pharmacy_id: pharmacyId
//         }
//         const response = await Axios.get('supervisor/pending-counselling', { params })
//         const data = response.data
//         return data;

//     } catch (error) {
//         return rejectWithValue(error.response)
//     }
// });

// export const PendingCounsellingCounts = createAsyncThunk('PendingCounsellingCounts', async ({ pharmacyId }, { rejectWithValue }) => {
//     try {
//         const params = {
//             pharmacy_id: pharmacyId
//         }
//         const response = await Axios.get('supervisor/pending-counts', { params })
//         const data = response.data
//         return data;

//     } catch (error) {
//         return rejectWithValue(error.response)
//     }
// });


// const initialState = {
//     loading: false,
//     data: null,
//     error: null
// }

// const PendingCounsellingSlice = createSlice({
//     name: 'fetchPendingCounsellingPatientsData',
//     initialState,

//     extraReducers: (builder) => {
//         builder.addCase(fetchPendingCounsellingPatientsData.pending.type, (state) => {
//             return {
//                 ...state,
//                 loading: true,
//                 data: null,
//                 error: null
//             }
//         })

//         builder.addCase(fetchPendingCounsellingPatientsData.fulfilled.type, (state, action) => {
//             return {
//                 ...state,
//                 loading: false,
//                 data: action.payload,
//                 error: null
//             }
//         })

//         builder.addCase(fetchPendingCounsellingPatientsData.rejected.type, (state, action) => {
//             return {
//                 ...state,
//                 loading: false,
//                 data: null,
//                 error: action.payload
//             }
//         })

//         builder.addCase(PendingCounsellingCounts.pending.type, (state) => {
//             return {
//                 ...state,
//                 loading: true,
//                 data: null,
//                 error: null
//             }
//         })

//         builder.addCase(PendingCounsellingCounts.fulfilled.type, (state, action) => {
//             return {
//                 ...state,
//                 loading: false,
//                 data: action.payload,
//                 error: null
//             }
//         })

//         builder.addCase(PendingCounsellingCounts.rejected.type, (state, action) => {
//             return {
//                 ...state,
//                 loading: false,
//                 data: null,
//                 error: action.payload
//             }
//         })

//     }

// })

// export default PendingCounsellingSlice.reducer
